import React from 'react'
import PropTypes from 'prop-types'
import { ToggleSwitch } from 'bs-unified-ui'

const Switch = ({ field, form, disabled, ...props }) => (
  <ToggleSwitch
    id="my-account__2fa"
    name={field.name}
    checked={field.value}
    onChange={(e) => {
      if (e.target.checked) {
        form.setFieldValue(field.name, e.target.checked)
      } else {
        form.setFieldValue(field.name, e.target.checked)
      }
    }}
    {...props}
    disabled={disabled || !!form.values.__readOnly}
  />
)

Switch.defaultProps = {
  disabled: false,
}

Switch.propTypes = {
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
}

export default Switch
